<div *ngIf="!organizationTreeSelect.company" class="alert alert-secondary m-2" role="alert">
  {{'company.select_company_alert' |translate}}
</div>
<mat-tab-group *ngIf="organizationTreeSelect.company">
  <mat-tab>
    <ng-template mat-tab-label><i class="material-icons">other_houses</i>&nbsp;Company overview</ng-template>
    <ng-template matTabContent>
      <div class="d-flex flex-column h-100">
        <div class="d-flex flex-row flex-wrap">
          <lib-prod-header [title]="detailsTitle" [icon]="'info_outline'" [class]="'company-upper'" style="flex: 1">
            <app-company-detail></app-company-detail>
          </lib-prod-header>
          <lib-prod-header [title]="batterySettingsTitle" [icon]="'battery_alert'" style="flex: 1" [class]="'company-upper'">
            <app-company-battery></app-company-battery>
          </lib-prod-header>
        </div>
        <app-site [companyEvent$]="companyEvent$" style="flex: 1"></app-site>
      </div>
    </ng-template>
  </mat-tab>
  <mat-tab *ngIf="isMember()" [disabled]="!organizationTreeSelect.company">
    <ng-template mat-tab-label><i class="material-icons">groups</i>&nbsp;Groups</ng-template>
    <ng-template matTabContent>
      <app-company-group></app-company-group>
    </ng-template>
  </mat-tab>
  <mat-tab *ngIf="isMember()" [disabled]="!organizationTreeSelect.company">
    <ng-template mat-tab-label><i class="material-icons">groups</i>&nbsp;Users</ng-template>
    <ng-template matTabContent>
      <app-users [companyTab]="true"></app-users>
    </ng-template>
  </mat-tab>
  <mat-tab [disabled]="!organizationTreeSelect.site">
    <ng-template mat-tab-label><i class="material-icons">house</i>&nbsp;Site settings</ng-template>
    <ng-template matTabContent>
      <div *ngIf="organizationTreeSelect.site">
        <app-site-detail></app-site-detail>
      </div>
      <div *ngIf="!organizationTreeSelect.site" class="alert alert-secondary m-2" role="alert">Please select a site
      </div>
    </ng-template>
  </mat-tab>
</mat-tab-group>
